import { Box, Card, Grid, Stack, Typography } from '@mui/material'
import StatusText from 'common/component/StatusText'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import defaultProductImage from '../../../assets/images/placeholderproduct.svg';
import colors from 'assets/theme/base/colors';
import { getReorderDrag, getStaticLegal } from '../../../redux/slices/common';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Loader from 'common/Loader';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import NoDataFound from 'common/component/NoDataFound';

const ReviewDetail = ({ legalId, fullRoleTabSlug }) => {
  const { grey } = colors;
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams();
  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
  const { singleLegal, isLoading } = useSelector((state => state.common));
  const [dragSection, setDragSection] = useState(singleLegal?.topicSection?.section || []);
  const [nodataFound, setNodataFound] = useState(false)
  const fullRoleTabheading = useMemo(() => searchParams.get('heading'), [searchParams]);

  // ************************************************** Get Data **************************************************
  useEffect(() => {
    if (fullRoleTabheading) {
      dispatch(getStaticLegal({ id: fullRoleTabheading, platform: fullRoleTab })).unwrap().then((res) => {
        setDragSection(res?.legalDetails?.topicSection?.section)
        setNodataFound(false)

      }).catch((err) => {
        setNodataFound(true)

      });
    }
  }, [fullRoleTabheading, fullRoleTab])

  // Handle drag end
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(dragSection);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const filteredData = items.map((item, index) => ({
      _id: item._id,
      order: index, // Reassign order based on position
    }));

    // ------------------------------------------api hit----------------------------------------------
    const payload = {
      "id": singleLegal?._id,
      "sectionType": "topicSection",
      sections: filteredData
    }
    dispatch(getReorderDrag(payload)).unwrap().then((res) => {
    }).catch((err) => {
    });
    // Update state to re-render the list
    setDragSection(items);
  };

  return (
    <>
      {
        isLoading ?
          <Loader /> :
          <>
            {
              nodataFound ? <NoDataFound /> :
                <Box p={4} pt={2} className="static-pages-container">

                  {/**************** Page Title ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
                      <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>{fullRoleTabheading}</Typography>
                      <StatusText status={singleLegal?.status ? "active" : "inactive"} />
                    </Stack>
                  </Card>

                  {/***************** Selected Platforms ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>

                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2} mt={2}>
                      <Typography variant='h5' fontWeight="semibold">Visible On</Typography>
                    </Stack>

                    <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }} mb={2}>
                      <Grid item xs={12}>
                        <Stack direction="row" alignItems="center" spacing={3}>
                          {singleLegal?.displaySettings?.footer && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Footer</badge>}
                          {singleLegal?.displaySettings?.hamburgerMenu && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Hamburger Menu</badge>}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Card>

                  {/***************** Meta Tags ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">Meta Properties</Typography>
                    </Stack>

                    <Grid container alignItems="center" spacing={3} mb={2}>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Meta Title</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.title ? singleLegal?.metaProperties?.title : "-"}</Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.description ? singleLegal?.metaProperties?.description : "-"}</Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Updated By</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.createdBy ? singleLegal?.createdBy : "-"}</Typography>
                      </Grid>

                    </Grid>
                  </Card>

                  {/***************** Top Banner ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">Header Section</Typography>
                      <StatusText status={singleLegal?.headerSection?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.headerSection?.status &&
                      <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={6}>
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Title(H1)</Typography>
                              <Typography variant='h5' fontWeight="medium">{singleLegal?.headerSection?.pageTitle ? singleLegal?.headerSection?.pageTitle : "-"}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                              <Typography
                                variant="h5"
                                fontWeight="medium"
                                dangerouslySetInnerHTML={{
                                  __html: singleLegal?.headerSection?.section?.description || "-",
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Info Text</Typography>
                              <Typography variant='h5' fontWeight="medium">{singleLegal?.bottomSection?.section?.title ? singleLegal?.bottomSection?.section?.title : "-"}</Typography>
                            </Grid>

                          </Grid>
                        </Grid>
                      </Grid>
                    }

                  </Card>

                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">Content Section</Typography>
                    </Stack>
                    <Typography
                      variant="h5"
                      fontWeight="medium"
                      dangerouslySetInnerHTML={{
                        __html: singleLegal?.bottomSection?.section?.description || "-",
                      }}
                    />
                  </Card>
                  {/***************** FAQ **************** */}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">FAQs</Typography>
                      <StatusText status={singleLegal?.faq?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.faq?.status && <>
                        {
                          singleLegal?.faq?.section?.length !== 0 ?

                            <Grid container alignItems="center">
                              {
                                singleLegal?.faq?.section?.map((data) => {
                                  return (
                                    <Grid item xs={12} mb={2} key={data.answer}>
                                      <Typography
                                        variant="h5"
                                        fontWeight="medium"
                                        dangerouslySetInnerHTML={{
                                          __html: data?.question || "-",
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        color={grey[600]}
                                        dangerouslySetInnerHTML={{
                                          __html: data?.answer || "-",
                                        }}
                                      />
                                    </Grid>
                                  )
                                })
                              }
                            </Grid>
                            : <NoDataFound />
                        }
                      </>
                    }
                  </Card>
                </Box>
            }
          </>
      }
    </>
  )
}

export default ReviewDetail